import {
  AndroidOutlined,
  AppleOutlined,
  SafetyCertificateOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import VehicleEdit from './VehicleEdit';
import TabDrivers from './TabDrivers';
import { useLocation, useParams, Location } from 'react-router';
import { Tabs } from 'antd';
import { useVehicleCompanyData } from '../../../../../../../Hooks/TT_ELD/Vehicles';
import VehicleIftaReport from './VehicleIftaReport';
import useRouteQuery from '../../../../../../../Utils/useRouterQuery';
import TruckCamera from './TruckCamera';
import { getUserFromLocalStorage } from '../../../../../../../Utils/sidebar';
import { isWhiteLabelAdmin } from '../../../../../../../Utils/whiteLabel';

// Truck Camera sends dashcam commands: internal support / developer / manager admins only,
// never white-label admins
const TRUCK_CAMERA_ROLES = ['support', 'support_manager', 'developer', 'manager'];

type MyObjectType = {
  [key: string | number]: any;
};
interface Params {
  id: string | undefined;

  [key: string]: string | undefined;
}

const VehicleTabs = ({ vehicleId }: { vehicleId: string | number }) => {
  const { id } = useParams<Params>();
  const [tabKey, setTabKey] = useRouteQuery('1', 'tabKey', (v) => String(v));
  const location: Location = useLocation();
  let vehicles = location.pathname === `/vehicles/vehicles/${id}`;

  const { data, isLoading, isFetching }: MyObjectType = useVehicleCompanyData(
    vehicles ? id : vehicleId,
  );

  const role = getUserFromLocalStorage()?.role ?? '';
  const canSeeTruckCamera = !isWhiteLabelAdmin() && TRUCK_CAMERA_ROLES.includes(role);

  const items = [
    {
      label: <span>MAIN FIELDS</span>,
      key: '1',
      children: <VehicleEdit vehicleId={vehicles ? id : vehicleId} />,
      icon: <AppleOutlined rev={undefined} />,
    },
    {
      label: <span>Vehicle Driver</span>,
      key: '2',
      children: (
        <TabDrivers
          driver={data?.driver}
          codriver={data?.codriver}
          isLoading={isLoading}
          isFetching={isFetching}
        />
      ),
      icon: <AndroidOutlined rev={undefined} />,
    },
    ...(canSeeTruckCamera
      ? [
          {
            label: <span>Truck Camera</span>,
            key: '3',
            children: <TruckCamera vehicleId={vehicles ? id : vehicleId} />,
            icon: <VideoCameraOutlined rev={undefined} />,
          },
        ]
      : []),
    // {
    //   label: <span>IFTA Report</span>,
    //   key: '3',
    //   children: <VehicleIftaReport companyId={data?.companyId} />,
    //   icon: <SafetyCertificateOutlined rev={undefined} />,
    // },
  ];

  return (
    <>
      <div style={{ padding: '12px 8px' }}>
        <Tabs
          onTabClick={(e) => {
            setTabKey(e);
          }}
          // A link to a tab this admin can't see (e.g. ?tabKey=3) falls back to Main Fields
          defaultActiveKey={items.some((tab) => tab.key === tabKey) ? tabKey : '1'}
          style={{ height: '100%' }}
          items={items.map((tab) => {
            return {
              label: tab.label,
              key: tab.key,
              children: tab.children,
              icon: tab.icon,
            };
          })}
        />
      </div>
    </>
  );
};

export default VehicleTabs;
